/**
 * NTRP Rating utilities
 * NTRP (National Tennis Rating Program) ratings range from 1.5 to 7.0 in 0.5 increments
 */

export const NTRP_RATINGS: number[] = [1.5, 2.0, 2.5, 3.0, 3.5, 4.0, 4.5, 5.0, 5.5, 6.0, 6.5, 7.0];

/**
 * Format NTRP rating for display
 * @param rating - The NTRP rating value (number or null)
 * @returns Formatted string representation of the rating
 */
export function formatNtrpRating(rating: number | null | undefined): string {
  if (rating === null || rating === undefined) {
    return 'Not set';
  }
  return rating.toFixed(1);
}

/**
 * Check if a value is a valid NTRP rating
 * @param value - The value to check
 * @returns True if the value is a valid NTRP rating
 */
export function isValidNtrpRating(value: number | null | undefined): boolean {
  if (value === null || value === undefined) {
    return true; // null/undefined is valid (not set)
  }
  return NTRP_RATINGS.includes(value);
}
